import Link from 'next/link';
import { useEffect, useState } from 'react';
import { FoamLogo } from '~/components/FoamLogo';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

export const MadeWithFOAM = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const { isEnabled: isMadeWithFoamEnabled } = useFeature(
    FEATURE_FLAGS.foamMediaKitsMadeWithFoam,
  );

  useEffect(() => {
    if (!isMadeWithFoamEnabled) return;

    const handleInteraction = () => {
      setHasInteracted(true);
    };
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    // Listen for user interactions
    window.addEventListener('click', handleInteraction);
    window.addEventListener('scroll', handleInteraction);
    window.addEventListener('keydown', handleInteraction);

    return () => {
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      clearTimeout(timer);
    };
  }, [hasInteracted, isMadeWithFoamEnabled]);

  if (!isMadeWithFoamEnabled) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-6 right-6 opacity-0 transition-all duration-1000 ease-in-out ${
        isVisible && hasInteracted
          ? '-translate-y-0 tab:opacity-100'
          : 'pointer-events-none translate-y-20 tab:opacity-50'
      }`}
    >
      <Link
        href="https://foam.io"
        className="group flex items-center gap-2 rounded-100 border border-neutral-50 bg-neutral-25 p-2 text-neutral-800 shadow-lg transition-all duration-300 hover:bg-neutral-100 hover:text-neutral-900"
        target="_blank"
        track-id="made-with-foam-link"
      >
        <FoamLogo width="1.5rem" height="1.5rem" color="neutral.900" />
        {/* eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values */}
        <span className="text-16 duration-500 group-hover:-translate-y-[1px]">
          Made with Foam
        </span>
      </Link>
    </div>
  );
};
